import type { FC } from "react";
import React from "react";

import { ButtonInline } from "../../../../ButtonInline";

import type { ButtonInlineProps } from "../../../../ButtonInline";
import type { IconProps } from "../../../../Icon";

const TAG_BUTTON_INLINE_TEST_ID = "tag-button-inline-test-id";

type AbsentedProps = "size" | "children";

interface ITagButtonInlineMain extends Pick<ButtonInlineProps, "size"> {}

interface ITagButtonInline
    extends Pick<IconProps, "icon">,
        Omit<ButtonInlineProps, AbsentedProps> {}

const TagButtonInline: FC<ITagButtonInline> = (props) => {
    const { icon, ...restProps } = props as ITagButtonInline &
        ITagButtonInlineMain;

    return (
        <ButtonInline
            {...(restProps as ButtonInlineProps)}
            view="custom"
            /** Переменные прилетают от родителя */
            customColorsStyles=""
            data-tsid={TAG_BUTTON_INLINE_TEST_ID}
        >
            <ButtonInline.RightIcon icon={icon} />
        </ButtonInline>
    );
};

TagButtonInline.displayName = "Tag.ButtonInline";

export default TagButtonInline;
